import sponsorsSlider from "./sponsors-slider"

export default {
	init() {
		const $load_novice_filter = $("#news-mozaik")
		const $load_novice_skeleton = $("#news-mozaik .novice-skeleton")
		const $searchNews_input = $("#search-news")
		const $searchNews_btn = $("#search-news-btn")
		const $posts_wrapper = $("#news-mozaik .more-posts")
		const $loadmoreNews_button = $("#news-mozaik .loadmore-category")
		const $more_wrapper = $("#news-mozaik .more-wrapper")

		let loaded_post_ids = [] // a list with current visible nnews IDs
		let page = 1
		let activeRequest = null
		let requestSerial = 0

		if ($load_novice_filter.length > 0) {
	
			let loaded_post_element = $("#loaded_post_ids")
	
			if (loaded_post_element.length) {
				if (loaded_post_element.val() != "") {	
					loaded_post_ids = loaded_post_element.val().split(",") // prepare visible nnews ID lis
				}
			}

			loadnovice() //  Initial loading of posts
			
			// Load More button trigger
			$loadmoreNews_button.on('click',function (e) {
				e.preventDefault()
				loadnovice(true)
			})

			// Change Filters
			$("input[type=radio][name=news-categories], select[name=order_select]").on('change', function (e) {
				page = 1
				loaded_post_ids = []

				// return Load more pages button
				$more_wrapper.css({ visibility: "visible" })
				$searchNews_input.val("")

				const $izkusnjaParent = $("input.izkusnja-parent");
				// check if this has a class 'filter-child'
				if ($(this).hasClass("izkusnja-child")) {
					$izkusnjaParent.addClass("checked-parent")
				} else {
					$izkusnjaParent.removeClass("checked-parent")
				}

				loadnovice()
			})


			$searchNews_input.on("keydown", function (e) {
				if (e.key == "Enter") {
					$searchNews_btn.trigger("click")
				}
			})
	
		
			$searchNews_btn.on('click', function (e) {
				$(this).prop("disabled", true)
	
				page = 1
				loaded_post_ids = []
	
				// Reset kategorije radio
				$("input[type=radio][name=news-categories]#kategorije-all").prop("checked",true)
	
				// return Load more pages button
				$more_wrapper.css({ visibility: "visible" })
	
				loadnovice()
			})
		}

		
		function loadnovice(loadmore = false) {
			let filterValues = getFilterValues()

			// console.log(filterValues)

			const requestedPage = loadmore ? page + 1 : 1

			if (!loadmore) {
				//skeleton
				$load_novice_skeleton.addClass("grid").show()
				$posts_wrapper.removeClass("grid").addClass("hidden")
			}

			const requestId = ++requestSerial
			if (activeRequest) {
				activeRequest.abort()
			}

			const data = {
				page: requestedPage,
				loaded_post_ids: loaded_post_ids,
				kategorija: filterValues.kategorija,
				search: filterValues.search,
				order_select: filterValues.order_select,
				language: filterValues.language,
			}

			activeRequest = $.ajax({
				url: '/wp-json/vivi/v1/novice',
				method: 'POST',
				data: data,
				beforeSend: function () {

					// Load more button
					if($loadmoreNews_button.length > 0) {
						$loadmoreNews_button.prop("disabled", true).text(loading_text)
					}
				},
				success: function (response) {
					if (requestId === requestSerial && response) {

						if (loadmore) {
							$posts_wrapper.append(response.content)
						} else {
							$posts_wrapper.html(response.content)

							//skeleton
							$load_novice_skeleton.hide()
							$posts_wrapper.removeClass("hidden").addClass("grid")
						}

						sponsorsSlider.init()

						page = requestedPage
						loaded_post_ids = Array.isArray(response.loaded_post_ids) ? response.loaded_post_ids : []

						const hasMore = typeof response.has_more === "boolean"
							? response.has_more
							: response.total > response.current_count
						$more_wrapper.css({ visibility: hasMore ? "visible" : "hidden" })
					}
				},
				error: function (xhr, status) {
					if (requestId !== requestSerial || status === "abort") {
						return
					}

					$load_novice_skeleton.hide()
					$posts_wrapper.removeClass("hidden").addClass("grid")
					console.error("News could not be loaded.", status)
				},
				complete: function () {
					if (requestId !== requestSerial) {
						return
					}

					activeRequest = null
					$searchNews_btn.prop("disabled", false)
					$loadmoreNews_button.prop("disabled", false).text(loading_more_text_simple)
				},
			})
		}


		function getFilterValues() {
			let language = document.documentElement.lang || "sl-SI"

			switch (language) {
				case "en-US":
					language = 'en';
					break;
					
				default:
					language = 'si';
					break;
			}

			let kategorija = $("input[name='news-categories']:checked")[0].value
			let search = $searchNews_input.val()
			let order_select = $("select[name='order_select']").val()
        
			return {
				'language': language,
                'kategorija': kategorija, 
				'search': search,
				'order_select': order_select
            }
		}
		
	}
}
